var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProject1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8315 2H6.16597C3.86886 2 2 3.86886 2 6.16597V16.8759C2 17.5366 2.36244 18.1415 2.94484 18.4539C3.2098 18.5964 3.50058 18.6664 3.79053 18.6664C4.13714 18.6664 4.48292 18.5656 4.78287 18.3664L8.08482 16.1643H12.8315C15.1286 16.1643 16.9975 14.2955 16.9975 11.9983V6.16597C16.9975 3.86886 15.1286 2 12.8315 2ZM21.9967 9.49875V20.2086C21.9967 20.8694 21.6342 21.4743 21.0518 21.7867C20.7869 21.9292 20.4961 21.9992 20.2061 22C19.8595 22 19.5137 21.8992 19.2146 21.7001L15.9118 19.4971H11.1651C9.95701 19.4971 8.87635 18.9713 8.11481 18.1473L8.5889 17.8307H12.8315C16.0468 17.8307 18.6639 15.2136 18.6639 11.9983V6.16597C18.6639 5.90935 18.6414 5.65939 18.6097 5.4111C20.5352 5.7777 21.9967 7.46826 21.9967 9.49875Z",
    fill: "#CAC4D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject1);
export default __webpack_public_path__ + "static/media/project1.80faef18.svg";
export { ForwardRef as ReactComponent };